export default {"src":"/_next/static/media/logo.3b286afc.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};